import './Economic_Research.css';
import brain2 from './brain-2.jpg';    
import Navbar from './Navbar.js';
import PDF from './pdf.js';
import Footer from './footer.js';
import video_brain from './brain-2.mp4';
import React, { useRef } from 'react';
import VideoPlayer from "./Video_Player.js";



const Economic_Research = () => {
  const videoRef = useRef(null);
  const lastTime = useRef(0);

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (!video) return;
    if (Math.abs(video.currentTime - lastTime.current) > 1) {
      video.currentTime = lastTime.current;
    } else {
      lastTime.current = video.currentTime;
    }
  };
  return (
    <div className="rational-page">
       <Navbar />
      <main className="rational-hero">
        <h1 >Cnyda Dynamics Research Division</h1>
        <div className="rational-content">
          <h1>Economic Research:</h1>
          <p>
             The objective of this paper is to critically review a research book on the world economy written nearly a decade ago.
             The book is an international publication by Emerald, published in London and catalogued by the British Library. 
             The motivation for reviewing this book is twofold. First, the book does not adhere to any single established school of economic thought such as Classical Economics, 
             Austrian School of Business Cycle Theory, New Keynesian Economics, or Modern Monetary Theory etc. Instead, the author develops an original analytical framework inspired by nonlinear dynamical systems and chaotic complex systems. This framework incorporates a large number of variables, 
             32 variables for each country across 12 major economies in the World and numerous parameters motivated by techniques from deep learning (32 variables, 3 states each, 12 countries, 30 years data). Moreover, the book conceptualizes the world economy as a single, interconnected entity composed of complex systems interacting in a nonlinear dynamic manner, 
             without imposing the explicit assumptions typically associated with conventional economic schools of thought.
          </p>
           <video 
              src={video_brain} 
              className="image_rational" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
          <p>
            Second, the book makes numerous long-term predictions about the world economy, projecting economic outcomes nearly a decade into the future for the world’s twelve largest economies, 
            which together account for a substantial share of global economic activity. These economies include the United States, China, Japan, India, Germany, the United Kingdom, France, Italy, Brazil, Russia, Canada, and Australia. 
            This paper critically evaluates the major predictions made by the book in the year 2017 and assesses their validity using recent economic data from 2024-2025. The book under review is Dynamics of Financial Stress and Economic Activity: Insights and Analysis from the World Economy [1].
         </p>
        </div>
        <div className="video-content-wrapper_em">
        <div className="video-header">
            <h1> Video White Paper </h1>
        </div>
        <VideoPlayer src="/paper_video.mp4" />
        <div className='pdf-paper'>
          <h1>Read Full White Paper</h1>
        </div>
          <PDF 
          title="White Paper" 
          file="/Paper_Book_prediction_v4.pdf" 
        />
      </div>
      </main> 
      <Footer/>
    </div>
  );
};

export default Economic_Research;